package horcrux.common.api.dtos.types

import kotlinx.serialization.Serializable

@Serializable
sealed interface DocumentRelationship {
    val documentRelationshipType: DocumentRelationshipType
}

@Serializable
enum class DocumentRelationshipType {
    ROOT, CHILD, ASSOCIATE;
}

@Serializable
data object RootDocumentRelationship : DocumentRelationship {
    override val documentRelationshipType: DocumentRelationshipType = DocumentRelationshipType.ROOT
}

@Serializable
sealed interface NonRootDocumentRelationship : DocumentRelationship {
    val relatedDocumentID: DocumentID
}

@Serializable
data class ChildDocumentRelationship(override val relatedDocumentID: DocumentID) : NonRootDocumentRelationship {
    override val documentRelationshipType: DocumentRelationshipType = DocumentRelationshipType.CHILD
}

@Serializable
data class AssociateDocumentRelationship(override val relatedDocumentID: DocumentID) : NonRootDocumentRelationship {
    override val documentRelationshipType: DocumentRelationshipType = DocumentRelationshipType.ASSOCIATE
}
